module.exports = "<p>\n  privacy-policy works!\n</p>\n"